
import Vue from "vue";
export default Vue.extend({
	props: {
		name: String,
		elementValue: String,
		checked: Boolean,
		label: [String, Object as ()=>{toString():string}],
		reverse: Boolean,
		disabled: Boolean
	},
	computed: {
		elementId():string {
			return "w-radio-" + (this as any)._uid;
		},
		inputElement():HTMLInputElement {
			return this.$refs.input as HTMLInputElement;
		}
	},
	methods: {
		clicked() {
			if (this.disabled) return;
			this.inputElement.click();
		},
		input(event:InputEvent) {
			if (this.disabled) {
				event.preventDefault();
				event.stopPropagation();
				return;
			}
			this.$emit("input", this.elementValue);
		}
	},
	created() {
		this.$emit("id", this.elementId);
	}
})
;